import { usePathname } from "next/navigation";

export function usePageLocationAsPerPath(leadFormPageLocation?: string): string {
  const pathname = usePathname();
  const lowerPath = pathname?.toLowerCase();

  const formNameMap: { keyword: string; name: string }[] = [
    { keyword: "community", name: "Community Page Lead Form" },
    { keyword: "project", name: "Project Page Lead Form" },
    { keyword: "property", name: "Property Type Page Lead Form" },
    { keyword: "blog", name: "Blog Page Lead Form" },
    { keyword: "seo-sale", name: "SEO Sale Page Lead Form" },
    { keyword: "article", name: "Article Page Lead Form" },
    { keyword: "checkout", name: "Checkout Lead Form" },
    { keyword: "webchat", name: "Webchat Lead Form" },
    { keyword: "whatsapp", name: "Whatsapp Lead Form" },
    { keyword: "expertise", name: "Our Expertise Lead Form" },
    { keyword: "offer", name: "Offer Page Lead Form" },
  ];

  const matchedForm = formNameMap?.find((item) => lowerPath?.includes(item?.keyword));
  return leadFormPageLocation || matchedForm?.name || "Header Lead Form";
}
